'use strict';

module.exports = br;

function br(h, node) {
  return h(node, 'break');
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/break.js
// module id = 1028
// module chunks = 0